<template lang="pug">
.bg-page
  .container
    .tickets-warning(v-if="ticketsWarning", style="margin-top:30px")
      h3 注意事項
      p
        |WirForce 官方販售 BYOC 門票不會額外收取報名服務費，欲報名者請以官方釋出的座位與消息為主。
        br
        |WirForce BYOC 進場門票採實名制登記，活動期間需驗證身分證件入場，若與他人協商座位導致當天無法進場，後果恕請自行負責。
        .btn.ghost-btn.red(@click="ticketsWarning = !ticketsWarning") 關閉
    flowStep(:flow="flow")
    .step-title(v-for="(step, key) in flow.steps", v-if="flow.actived == key")
      .circle
        .number {{ key }}
      h1 {{ step }}
    router-view(:isMobile="isMobile", :isLogin="isLogin")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import flowStep from '@/components/booking/flowStep'
// import _ from 'lodash'

export default {
  name: 'booking',
  props: {
    isMobile: {
      type: Boolean
    },
    isLogin: {
      type: Boolean
    }
  },
  components: {
    'flowStep': flowStep
  },
  data () {
    return {
      ticketsWarning: true,
      flow: {
        actived: 1,
        steps: {
          1: '選擇區域',
          2: '選擇座位'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    ...mapActions([
    ])
  },
  updated () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
.step-title
  .circle
    float: left
    position: relative
    background-color: #fff
    +border-radius(50%)
    width: 24px
    height: 24px
    display: inline-block
    text-align: center
    margin-right: 8px
    .number
      color: $black
      line-height: 24px
  h1
    font-size: 26px
    line-height: 24px
</style>



// WEBPACK FOOTER //
// booking.vue?5c13030d